/**
 * Permission catalogue. Every permission belongs to exactly one module, so switching a module off
 * for a tenant also removes everything its permissions unlock.
 */
export const PERMISSIONS = {
    // administration (always on)
    'org.settings.manage': 'Change organisation settings and branding',
    'users.read': 'View users',
    'users.manage': 'Invite, update and deactivate users',
    'roles.manage': 'Create and edit roles',
    'audit.read': 'View the audit log',
    // compliance (always on)
    'compliance.view': 'View compliance alerts and the flags panel',
    'exports.run': 'Run CSV exports (audited)',
    // work
    'myday.use': 'Work from My Day',
    'myday.view_others': "View other users' My Day (read-only)",
    'pipeline.read': 'View accounts, contacts and the pipeline',
    'pipeline.write': 'Create and update accounts, contacts and opportunities',
    'targets.manage': 'Set targets',
    'touches.write': 'Log touches',
    'import.run': 'Import CSV data',
    // setup
    'playbook.read': 'View the playbook, ICPs and pitches',
    'playbook.manage': 'Change the playbook, ICPs and pitches',
    'library.read': 'Read cheat sheets and checklists',
    'library.manage': 'Edit cheat sheets and checklists',
    // insights
    'dashboards.read': 'View dashboards',
    'alerts.read': 'View alerts',
    'performance.read': 'View the performance indicator',
    'flags.view': 'View consistency flags',
    'effort.write': 'Enter time spent',
    // automation
    'automation.manage': 'Pause and resume automations',
    'email.approve': 'Approve the daily email queue',
    'email.templates.manage': 'Manage email templates and senders',
    // intelligence
    'ai.read': 'View AI recommendations and reports',
    'ai.profile.manage': 'Manage AI providers, models and prompts',
    'lookalike.review': 'Review lookalike suggestions',
};
export const ALL_PERMISSIONS = Object.keys(PERMISSIONS);
export function isPermission(value) {
    return Object.hasOwn(PERMISSIONS, value);
}
/** System roles created for every new tenant. Tenants may add their own roles later. */
export const SYSTEM_ROLES = {
    tenant_admin: {
        name: 'Tenant Admin',
        description: 'CEO / Admin: full control of this organisation',
        permissions: ALL_PERMISSIONS,
    },
    bdm: {
        name: 'Business Development Manager',
        description: 'Works from My Day, logs touches, moves cards, approves the email queue',
        permissions: [
            'users.read',
            'myday.use',
            'pipeline.read',
            'pipeline.write',
            'touches.write',
            'playbook.read',
            'library.read',
            'dashboards.read',
            'alerts.read',
            'performance.read',
            'effort.write',
            'email.approve',
            'ai.read',
            'lookalike.review',
        ],
    },
};
//# sourceMappingURL=permissions.js.map